import http from "@/http-common"

class UberallDataService {

  /**
   * Synchronize all establishment informations in all diffusers
   * @param establishmentId
   * @param headers
   * @returns
   */
  syncLocation(establishmentId: number, headers: {}): Promise<any> {
    return http.get(`auth/establishments/sync/` + establishmentId, { headers: headers })
  }
}

export default new UberallDataService()
